import { render, staticRenderFns } from "./DictRadioGroup.vue?vue&type=template&id=99c18bb8"
import script from "./DictRadioGroup.vue?vue&type=script&lang=js"
export * from "./DictRadioGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports